import React from 'react'

const FooterInfo = ({icon, heading, text}) => {
    return (
        <div class="data">
            <div>
                <i class={icon}></i>
            </div>
            <div>
                <h3>{heading}</h3>
                <p>{text}</p>
            </div>
        </div>
    )
}

export default FooterInfo
